import { Order } from '../models';

export const orderHasAttachments = (order: Order): boolean =>
  Array.isArray(order.attachments) && order.attachments.length > 0;

export const countOrderAttachments = (order: Order): number => order.attachments?.length ?? 0;

export const hasAnyOrderWithAttachments = (orders: Order[] = []): boolean => orders.some(orderHasAttachments);
